import { AppointmentAdvancePaymentRefund } from '@dreryk/egabinet-appointment-advance-payment-frontend-api';

import { createVisitor } from '~libs.typescript';

export const appointmentAdvancePaymentAutomaticRefundVisitor = createVisitor<
   {
      automaticRefundEnabled: boolean;
      appointmentAdvancePaymentRefund: AppointmentAdvancePaymentRefund | null;
   },
   {
      visitWithAutomaticRefund: AppointmentAdvancePaymentRefund;
      visitWithoutAutomaticRefund: void;
   }
>((data, visitor) => {
   if (data.automaticRefundEnabled && data.appointmentAdvancePaymentRefund) {
      return visitor.visitWithAutomaticRefund?.(data.appointmentAdvancePaymentRefund);
   }

   return visitor.visitWithoutAutomaticRefund?.();
});
